import { useTrackExternalCalendarConnected } from 'features/external-connections';
import React from 'react';

// Below Root's Suspense boundary: these hooks read suspending queries, which from Root's body would blank the shell.
export const RootTracking: React.FC = () => {
  useTrackExternalCalendarConnected();

  return null;
};
